import { render, staticRenderFns } from "./ExamMarkViewPage.vue?vue&type=template&id=cbe6fe66&scoped=true&"
import script from "./ExamMarkViewPage.vue?vue&type=script&lang=js&"
export * from "./ExamMarkViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamMarkViewPage.vue?vue&type=style&index=0&id=cbe6fe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe6fe66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
